import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
export function TruthShiftSection() {
  return <SectionWrapper bgColor="sand" data-id="element-130">
      <div className="text-center max-w-3xl mx-auto space-y-8" data-id="element-131">
        <h2 className="text-3xl md:text-4xl lg:text-5xl text-text leading-tight" data-id="element-132">
          "Cuando no regulás tu energía, tu entorno empieza a decidir por vos."
        </h2>
        <p className="text-lg md:text-xl text-text-secondary max-w-2xl mx-auto" data-id="element-133">
          Y eso tiene un costo emocional que no siempre ves.
        </p>
        <p className="text-base md:text-lg text-text-secondary/80 max-w-2xl mx-auto" data-id="element-134">
          No es falta de fortaleza. Es falta de un sistema claro que te devuelva
          el control.
        </p>
      </div>
    </SectionWrapper>;
}